export const INITIAL_CONFIG_KEY = "default";
export const DEFAULT_CONFIG_KEY = "defaultConfigKey";
export const SAVED_CONFIG_KEY   = "currentConfigName";
export const SAVED_CREDS_KEY    = "authHeaders";

export const APP_INITIALIZED = 'APP_INITIALIZED';

export const QUOTE_CALCULATED = 'QUOTE_CALCULATED';
export const QUOTES_FETCHED = 'QUOTES_FETCHED';

export const APPLICATION_CREATION_FAILED = 'APPLICATION_CREATION_FAILED';
export const APPLICATION_CREATION_REQUESTED = 'APPLICATION_CREATION_REQUESTED';
export const APPLICATION_CREATED = 'APPLICATION_CREATED';

export const APPLICATION_FETCH_FAILED = 'APPLICATION_FETCH_FAILED';
export const APPLICATION_FETCH_REQUESTED = 'APPLICATION_FETCH_REQUESTED';
export const APPLICATION_FETCHED = 'APPLICATION_FETCHED';

export const APPLICATION_UPDATE_FAILED = 'APPLICATION_UPDATE_FAILED';
export const APPLICATION_UPDATE_REQUESTED = 'APPLICATION_UPDATE_REQUESTED';
export const APPLICATION_UPDATED = 'APPLICATION_UPDATED';

export const APPLICATION_REWIND_FAILED = 'APPLICATION_REWIND_FAILED';
export const APPLICATION_REWIND_REQUESTED = 'APPLICATION_REWIND_REQUESTED';
export const APPLICATION_REWOUND = 'APPLICATION_REWOUND';

export const XERO_ORGANISATION_FETCH_REQUESTED = 'XERO_ORGANISATION_FETCH_REQUESTED';
export const XERO_ORGANISATION_FETCH_FAILED = 'XERO_ORGANISATION_FETCH_FAILED';
export const XERO_ORGANISATION_FETCHED = 'XERO_ORGANISATION_FETCHED';

export const APPLICATION_NUMBER = 'APPLICATION_NUMBER';



// WEBPACK FOOTER //
// ./src/utils/constants.js